import React from 'react';
import loadable from '@loadable/component';
import { Spin } from '@arco-design/web-react';
import styles from '../style/layout.module.less';

function LoadingComponent() {
  return (
    <div className={styles.spin}>
      <Spin />
    </div>
  );
}

export default function lazyload(loader: () => Promise<{ default: React.ComponentType }>) {
  return loadable(loader, {
    fallback: <LoadingComponent />,
  });
}
